<template>
  <div
    class="wg-our-menu"
    :style="`background-image: url('${getImageUrl(
      menu.home_menu_image
    )}'); background-size: cover; background-repeat: no-repeat; background-position: center center;`"
  >
  
    <div class="themesflat-container">
      <div class="row">
        <div class="col-md-5 align-items-center">
          <div class="content">
            <img
              class=""
              src="assets/images/item-background/menu-1.png"
              alt=""
            />
            <div class="heading-section">
              <div class="sub " :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ menu.home_menu_title }}</div>
              <div class="main " style="text-transform: uppercase;" :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ $t('from_our_menu') }}</div>
              <div class="divider "><div></div></div>
            </div>
            <p class="">
              {{ menu.home_menu_description }}
            </p>
            <router-link to="/menu" class="button-two-line " style="text-transform: uppercase;">{{ $t('view_all_menu') }}</router-link>
          </div>
        </div>
        <MenuItemsComponent />
      </div>
    </div>
  </div>
</template>

<script>
import MenuItemsComponent from "@/components/home/MenuItemsComponent.vue";
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "MenuComponent",
  components: {
    MenuItemsComponent,
  },
  props: {
    msg: String,
  },

  data() {
    return {
      langStore,
      menu: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchMenu();
    },
  },

  mounted() {
    this.fetchMenu();
  },

  methods: {
     async fetchMenu() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/home-menu`,
          { params: { lang: this.langStore.lang } }
        );

        this.menu = response.data;

        // WAIT FOR IMAGES TO LOAD
        this.waitForImages();
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },
    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + photo;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
